import cn from 'classnames';
import ruLocale from 'date-fns/locale/ru';
import { useEffect, type FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { BirhdayDateIcon } from '@shared/assets';
import { useMobile } from '@shared/hooks/index.ts';
import { Card } from '@shared/ui';
import type { IClientForm } from '../../model';
import * as st from './styles.module.scss';

type Props = {
  disabled?: boolean;
  isLoading?: boolean;
};

export const Birthday: FC<Props> = ({ disabled, isLoading }): JSX.Element => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const { isMobile } = useMobile();
  const errorMessage = errors?.birth_date?.message as string;

  const localFormSave: IClientForm | null = JSON.parse(
    localStorage.getItem('clientEditorFormState')!
  );

  useEffect(() => {
    if (localFormSave !== null && localFormSave.birth_date !== null) {
      const birth_d = new Date(localFormSave.birth_date);
      setValue('birth_date', birth_d, { shouldValidate: true, shouldDirty: true });
    }
  }, []);

  return (
    <>
      <fieldset className={st.main}>
        <div className={st.main__header}>
          <h3>Дата рождения</h3>
          <p>{errorMessage}</p>
        </div>
        <div className={st.blocks}>
          <Card className={st.contact}>
            <div className={st.wrapper}>
              <Controller
                control={control}
                name="birth_date"
                render={({ field: { value, onChange } }) => (
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ruLocale}>
                    <DesktopDatePicker
                      disabled={disabled || isLoading}
                      label=""
                      value={value}
                      onChange={onChange}
                      format="dd.MM.yyyy"
                      // defaultValue={'__.__.____'}
                      className={cn(
                        st.date,
                        errorMessage && st.dateError,
                        (disabled || isLoading) && st.disabled
                      )}
                      slots={{ openPickerIcon: BirhdayDateIcon }}
                      slotProps={{
                        popper: {
                          sx: {
                            ...{
                              '& .MuiDateCalendar-root': {
                                width: isMobile ? 'calc(100vw - 60px)' : '330px',
                              },
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
              />
            </div>
          </Card>
        </div>
      </fieldset>
    </>
  );
};
